import React from 'react';
import ReactDOM from 'react-dom';
import { Scada } from './Scada';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
   <Scada/>,
  document.getElementById('root')
);

// Registra el service worker para convertirla en PWA instalable
serviceWorkerRegistration.register();